import React, { Component } from 'react';
import { getStackFrames } from './react-error-overlay/utils/getStackFrames.js';
import StackTrace from './react-error-overlay/containers/StackTrace.js';
import openFile from './openFile.js';
const rootStyle = { padding: '5px 10px' };
export class TraceTab extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            stackFrames: [],
        };
        this.onStackLocationClicked = (fileLocation = {}) => {
            // console.log("Stack location args: ", ...args);
            const { fileName, lineNumber } = fileLocation;
            if (fileName && lineNumber) {
                const matchingStackFrame = this.state.stackFrames.find((stackFrame) => {
                    const matches = (stackFrame._originalFileName === fileName &&
                        stackFrame._originalLineNumber === lineNumber) ||
                        (stackFrame.fileName === fileName &&
                            stackFrame.lineNumber === lineNumber);
                    return matches;
                });
                // console.log("Matching stack frame: ", matchingStackFrame);
                if (matchingStackFrame) {
                    /*
                    const frameIndex = this.state.stackFrames.indexOf(matchingStackFrame);
                    const originalStackFrame = parsedFramesNoSourcemaps[frameIndex];
                    console.log("Original stack frame: ", originalStackFrame);
                    */
                    this.props.openFile(fileName, lineNumber, matchingStackFrame);
                }
            }
        };
        this.openDocs = (e) => {
            e.stopPropagation();
            window.open('https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/Features/Trace.md');
        };
    }
    componentDidMount() {
        // console.log("StackTraceTab mounted");
        this.checkForStackTrace();
    }
    componentDidUpdate(prevProps) {
        const { action, actions } = prevProps;
        if (action !== this.props.action || actions !== this.props.actions) {
            this.checkForStackTrace();
        }
    }
    checkForStackTrace() {
        const { action, actions: liftedActionsById } = this.props;
        if (!action) {
            return;
        }
        const liftedActions = Object.values(liftedActionsById);
        const liftedAction = liftedActions.find((liftedAction) => liftedAction.action === action);
        if (liftedAction && typeof liftedAction.stack === 'string') {
            const deserializedError = Object.assign(new Error(), {
                stack: liftedAction.stack,
            });
            getStackFrames(deserializedError)
                .then((stackFrames) => {
                this.setState({
                    stackFrames: stackFrames,
                    currentError: deserializedError,
                });
            })
                .catch(() => {
                // noop
            });
        }
        else {
            this.setState({
                stackFrames: [],
                showDocsLink: !!liftedAction.action &&
                    !!liftedAction.action.type &&
                    liftedAction.action.type !== '@@INIT',
            });
        }
    }
    render() {
        const { stackFrames, showDocsLink } = this.state;
        if (showDocsLink) {
            return (React.createElement("div", { style: rootStyle },
                "To enable tracing action calls, you should set `trace` option to `true` for Redux DevTools enhancer. Refer to",
                ' ',
                React.createElement("a", { href: "#", onClick: this.openDocs }, "this page"),
                ' ',
                "for more details."));
        }
        return (React.createElement("div", { style: rootStyle },
            React.createElement(StackTrace, { stackFrames: stackFrames, errorName: "N/A", contextSize: 3, editorHandler: this.onStackLocationClicked })));
    }
}
TraceTab.defaultProps = {
    openFile,
};
